import { common } from '@kurtosys/ksys-app-template';

const targetTranslations: any = {
	resourceEfficientEuropeanEquitiesFund: 'FR_Resource Efficient European Equities Fund',
	'Items per page:': 'Objets par page:',
	'of {totalPages}': 'sur {totalPages}',
	'{firstItem} - {lastItem} of {totalRows} items': '{firstItem} - {lastItem} éléments sur {totalRows}',
	Page: 'Le Page',
};

const fallbackTranslations: any = {
	resourceEfficientEuropeanEquitiesFund: 'EN_Resource Efficient European Equities Fund',
	msciEurope: 'EN_MSCI Europe',
	'Items per page:': 'Objets par page:',
	threshold_1: 'threshold translated',
	'Page A': 'translated Page A',
	xAxisLabel: 'xAxisLabel Translated',
	yAxisLabel: 'yAxisLabel Translated',
};

export const getTranslateFn = (mustTranslate: boolean) => {
	return mustTranslate
		? translate
		: (key: string) => {
				return key;
		  };
};

export const translate = (key: string, placeholders?: any) => {
	const translation = getTranslation(key);
	return placeholders
		? common.commonUtils.replacePlaceholders({ values: placeholders, text: translation })
		: translation;
};

const getTranslation = (key: string) => {
	return targetTranslations[key] || fallbackTranslations[key] || key;
};
